import React, { useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  NavDropdown,
  Badge,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import colors from "../../constants/colors";
import { useCart } from "../../context/CartContext";
//import Logo from "../Logo/Logo";
import { useMediaQuery } from "react-responsive";
import {
  FaUserCircle,
  FaUser,
  FaShoppingBag,
  FaCog,
  FaSignOutAlt,
  FaShoppingCart,
} from "react-icons/fa";

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const { user, logout } = useAuth();
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const totalItems =
    cartItems?.reduce((acc, item) => acc + item.quantity, 0) || 0;

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Erro ao realizar logout:", error);
    }
    setExpanded(false);
  };

  const UserDropdown = ({ user, isMobile, setExpanded, handleLogout }) => {
    return (
      <div
        className={`d-flex ${isMobile ? "flex-column" : "flex-row"
          } align-items-start`}
      >
        {/* Dropdown do Usuário */}
        {user ? (
          <NavDropdown
            title={
              <span className="align-items-center">
                <FaUserCircle
                  className="me-2"
                  style={{ color: colors.dark, fontSize: "1.2rem" }}
                />
                {isMobile ? "A minha conta" : user.username || "A minha conta"}
              </span>
            }
            id="user-dropdown"
            align="end"
            className="m-md-2 rounded"
            menuVariant="dark"
            style={{
              backgroundColor: colors.primary,
              color: colors.dark,
              fontWeight: "500",
              transition: "all 0.3s ease",
            }}
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = colors.primary)
            }
          >
            <div
              className="p-2"
              style={{
                backgroundColor: colors.dark,
                borderRadius: "8px",
                minWidth: "200px",
              }}
            >
              {/* Perfil */}
              <NavDropdown.Item
                as={Link}
                to="/perfil"
                onClick={() => setExpanded(false)}
                className="rounded mb-1 text-light d-flex align-items-center"
                style={{
                  backgroundColor: colors.secondary,
                  padding: "10px 15px",
                  transition: "all 0.3s ease",
                  color: colors.light,
                  fontWeight: "400",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = colors.dark;
                  e.currentTarget.style.color = colors.primary;
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = colors.secondary;
                  e.currentTarget.style.color = colors.light;
                }}
              >
                <FaUser
                  className="me-2"
                  style={{ fontSize: "1.1rem", color: colors.light }}
                />
                O meu perfil
              </NavDropdown.Item>

              {/* Encomendas */}
              <NavDropdown.Item
                as={Link}
                to="/minhas-encomendas"
                onClick={() => setExpanded(false)}
                className="rounded mb-1 text-light d-flex align-items-center"
                style={{
                  backgroundColor: colors.secondary,
                  padding: "10px 15px",
                  transition: "all 0.3s ease",
                  color: colors.light,
                  fontWeight: "400",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = colors.dark;
                  e.currentTarget.style.color = colors.primary;
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = colors.secondary;
                  e.currentTarget.style.color = colors.light;
                }}
              >
                <FaShoppingBag
                  className="me-2"
                  style={{ fontSize: "1.1rem", color: colors.light }}
                />
                As minhas encomendas
              </NavDropdown.Item>

              {/* Admin Dashboard (se usuário for admin) */}
              {user.isAdmin && (
                <NavDropdown.Item
                  as={Link}
                  to="/admin-dashboard"
                  onClick={() => setExpanded(false)}
                  className="rounded mb-1 text-light d-flex align-items-center"
                  style={{
                    backgroundColor: colors.secondary,
                    padding: "10px 15px",
                    transition: "all 0.3s ease",
                    color: colors.light,
                    fontWeight: "400",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = colors.dark;
                    e.currentTarget.style.color = colors.primary;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = colors.secondary;
                    e.currentTarget.style.color = colors.light;
                  }}
                >
                  <FaCog
                    className="me-2"
                    style={{ fontSize: "1.1rem", color: colors.light }}
                  />
                  Admin Dashboard
                </NavDropdown.Item>
              )}

              {/* Divisor */}
              <NavDropdown.Divider
                className="my-2"
                style={{ borderColor: colors.textGray, opacity: 0.5 }}
              />

              {/* Logout */}
              <NavDropdown.Item
                onClick={handleLogout}
                className="rounded text-light d-flex align-items-center"
                style={{
                  backgroundColor: colors.danger,
                  padding: "10px 15px",
                  transition: "all 0.3s ease",
                  color: colors.light,
                  fontWeight: "400",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = colors.dark;
                  e.currentTarget.style.color = colors.primary;
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = colors.danger;
                  e.currentTarget.style.color = colors.light;
                }}
              >
                <FaSignOutAlt
                  className="me-2"
                  style={{ fontSize: "1.1rem", color: colors.light }}
                />
                Sair
              </NavDropdown.Item>
            </div>
          </NavDropdown>
        ) : (
          <Button
            as={Link}
            to="/login"
            className="m-md-2"
            onClick={() => setExpanded(false)}
            style={{
              backgroundColor: colors.dark,
              color: colors.primary,
              borderColor: colors.primary,
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <FaUser className="me-2" /> Login
          </Button>
        )}
      </div>
    );
  };

  return (
    <Navbar
      style={{ backgroundColor: colors.primary }}
      expand="md"
      expanded={expanded}
      className="py-3 shadow-sm"
    >
      <Container>
        {/*<Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <Logo size="small" />
        </Navbar.Brand>*/}

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(expanded ? false : "expanded")}
          className="me-2 border-0"
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              as={Link}
              to="/produtos"
              onClick={() => setExpanded(false)}
              className="mx-2"
              style={{ color: colors.dark }}
              onMouseOver={(e) => (e.currentTarget.style.color = colors.darker)}
              onMouseOut={(e) => (e.currentTarget.style.color = colors.dark)}
            >
              Produtos
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/produtos-digitais"
              onClick={() => setExpanded(false)}
              className="mx-2"
              style={{ color: colors.dark }}
              onMouseOver={(e) => (e.currentTarget.style.color = colors.darker)}
              onMouseOut={(e) => (e.currentTarget.style.color = colors.dark)}
            >
              Produtos Digitais
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/servicos"
              onClick={() => setExpanded(false)}
              className="mx-2"
              style={{ color: colors.dark }}
              onMouseOver={(e) => (e.currentTarget.style.color = colors.darker)}
              onMouseOut={(e) => (e.currentTarget.style.color = colors.dark)}
            >
              Serviços
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contactos"
              onClick={() => setExpanded(false)}
              className="mx-2"
              style={{ color: colors.dark }}
              onMouseOver={(e) => (e.currentTarget.style.color = colors.darker)}
              onMouseOut={(e) => (e.currentTarget.style.color = colors.dark)}
            >
              Contactos
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/sobre"
              onClick={() => setExpanded(false)}
              className="mx-2"
              style={{ color: colors.dark }}
              onMouseOver={(e) => (e.currentTarget.style.color = colors.darker)}
              onMouseOut={(e) => (e.currentTarget.style.color = colors.dark)}
            >
              Sobre
            </Nav.Link>
          </Nav>

          <Nav className="align-items-md-center">
            {user ? (
              <UserDropdown
                user={user}
                isMobile={isMobile}
                setExpanded={setExpanded}
                handleLogout={handleLogout}
              />
            ) : (
              <Button
                as={Link}
                to="/login"
                className="m-md-2"
                onClick={() => setExpanded(false)}
                style={{
                  backgroundColor: colors.dark,
                  color: colors.primary,
                  borderColor: colors.primary,
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <FaUser className="me-2" /> Login
              </Button>
            )}
            <Button
              as={Link}
              to="/carrinho"
              onClick={() => setExpanded(false)}
              className="m-md-2 position-relative"
              style={{
                backgroundColor: colors.secondary,
                borderColor: colors.secondary,
                color: colors.primary,
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <FaShoppingCart className="me-2" /> Carrinho
              {totalItems > 0 && (
                <Badge
                  pill
                  bg="danger"
                  className="position-absolute top-0 start-100 translate-middle"
                >
                  {totalItems}
                </Badge>
              )}
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;